import {request} from '@/helpers/apiClient'
import {FILE_UPLOAD_CONFIG} from '@/utils/constants/apiConfig/fileUploadConfig'
import {Constants} from '@/utils/constants/commonConstants'

export const getFileVerification = async (formData, uploadFor) => {
  /* We can add switch case to handle different uploadFor cases */
  if (uploadFor && uploadFor === Constants.SalesTargetMedia) {
    return request(FILE_UPLOAD_CONFIG.UPLOAD_SALES_TARGET_CONTENT, {data: formData}, 'type=' + Constants.Public)
  }
  if (uploadFor && uploadFor === Constants.BulkModifiers) {
    return request(FILE_UPLOAD_CONFIG.UPLOAD_BULK_MODIFIER_FILE, {body: formData})
  }
  return request(FILE_UPLOAD_CONFIG.UPLOAD_FILE, {body: formData})
}
